import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../config';
import { headers } from '../../token';
import { Link } from 'react-router-dom';
import vAdminformat from '../../adminFormat';
import validateError from '../../ValidateError';

const server_backend = config.API_URL;

function UpdateCustomer({ username, onCustomerID, onClose, getCustomers }) {
    const [loading, setLoading] = useState(false);

    const [userCreated, setUserCreated] = useState("");
    const [userModify, setUserModify] = useState("");
    const [dateCreated, setDateCreated] = useState("");
    const [dateModify, setDateModify] = useState("");

    const [formData, setFormData] = useState({
        id: onCustomerID,
        name: "",
        lastname: "",
        email: "",
        phone: "",
        phone2: "",
        dni: "",
        address: "",
        city: "",
        zipcode: "",
        country: "",
        shipping_address: "",
        shipping_city: "",
        shipping_zipcode: "",
        shipping_country: "",
        contact_fullname: "",
        contact_phone: "",
        contact_email: "",
        reference1: "",
        reference2: "",
        comment: "",
        est_id: "",
        user_transaction: username,
    });

    useEffect(() => {
        const fetchCustomer = async () => {
            try {
                const response = await axios.get(`${server_backend}/Customers/select?id=${onCustomerID}`, headers);

                if (response.data.RES_CODE === "00") {
                    const data = response.data.RES_RESULT[0];
                    setUserCreated(data.user_created);
                    setUserModify(data.user_modify);
                    setDateCreated(data.date_created);
                    setDateModify(data.date_modify);
                    setFormData({
                        id: data.cust_ID,
                        name: data.name,
                        lastname: data.lastname,
                        email: data.email,
                        phone: data.phone,
                        phone2: data.phone2,
                        dni: data.dni,
                        address: data.address,
                        city: data.city,
                        zipcode: data.zipcode,
                        country: data.country,
                        shipping_address: data.shipping_address,
                        shipping_city: data.shipping_city,
                        shipping_zipcode: data.shipping_zipcode,
                        shipping_country: data.shipping_country,
                        contact_fullname: data.contact_fullname,
                        contact_phone: data.contact_phone,
                        contact_email: data.contact_email,
                        reference1: data.reference1,
                        reference2: data.reference2,
                        comment: data.comment,
                        est_id: data.est_ID,
                        user_transaction: username
                    });
                }
            } catch (error) {
                console.log(error);
            }
        };
        fetchCustomer();
    }, [onCustomerID, username]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        //setLoading(true);

        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to save this transaction?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {

                try {
                    const response = await axios.post(`${server_backend}/Customers/update`, formData, headers);
                    if (response.data.RES_CODE === "00") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Updated Successfully',
                            showConfirmButton: false,
                            timer: 2000
                        });
                        onClose();
                        getCustomers();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error updating customer',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                } catch (error) {
                    const message = validateError(error);

                    Swal.fire({
                        icon: 'error',
                        title: message,
                        showConfirmButton: false,
                        timer: 2000
                    });
                }

            }
        });
    };

    return (
        <div className="row">
            <div className="card">
                <div className="card-header align-items-center d-flex">
                    <div className="col-md-12">
                        <div className="text-end">
                            <Link className='btn btn-danger' style={{ marginRight: "5px" }} onClick={() => {

                                Swal.fire({
                                    icon: 'warning',
                                    title: 'Alert',
                                    text: "Are you sure you want to discard these changes?",
                                    showCancelButton: true,
                                    confirmButtonText: 'Accept',
                                    cancelButtonText: "Cancel"
                                }).then(async (result) => {
                                    if (result.isConfirmed) {
                                        onClose();
                                    }
                                }
                                )
                            }
                            }>Discard Change</Link>
                            <Link to="#" onClick={handleUpdate} className="btn btn-primary">
                                {loading ? "Loading..." : "Update"}
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="modal-body">
                    <form onSubmit={handleUpdate}>
                        <div className="row">
                            <form>
                                <div className="card mb-3">
                                    <div className="card-header">
                                        <h5>User Information</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="row mb-3">
                                            <div className="col-sm-6">
                                                <label htmlFor="name" className="form-label">Name</label>
                                                <input type="text" className="form-control" id="name" name="name" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
                                            </div>
                                            <div className="col-sm-6">
                                                <label htmlFor="lastname" className="form-label">Lastname</label>
                                                <input type="text" className="form-control" id="lastname" name="lastname" value={formData.lastname} onChange={(e) => setFormData({ ...formData, lastname: e.target.value })} />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-6">
                                                <label htmlFor="phone" className="form-label">Phone</label>
                                                <input type="text" className="form-control" id="phone" name="phone" value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })} />
                                            </div>
                                            <div className="col-sm-6">
                                                <label htmlFor="phone2" className="form-label">Secondary Phone</label>
                                                <input type="text" className="form-control" id="phone2" name="phone2" value={formData.phone2} onChange={(e) => setFormData({ ...formData, phone2: e.target.value })} />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-6">
                                                <label htmlFor="email" className="form-label">Email</label>
                                                <input type="email" className="form-control" id="email" name="email" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} />
                                            </div>
                                            <div className="col-sm-6">
                                                <label htmlFor="dni" className="form-label">DNI</label>
                                                <input type="text" className="form-control" id="dni" name="dni" value={formData.dni} onChange={(e) => setFormData({ ...formData, dni: e.target.value })} />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="card mb-3">
                                    <div className="card-body">
                                        <div className="row mb-3">
                                            <div className="col-sm-6">
                                                <center><h5 className="card-title mb-3">Billing address </h5></center>
                                                <label htmlFor="address" className="form-label">Address</label>
                                                <input type="text" className="form-control" id="address" name="address" value={formData.address} onChange={(e) => setFormData({ ...formData, address: e.target.value })} />
                                                <label htmlFor="City" className="form-label">City</label>
                                                <input type="text" className="form-control" id="city" name="city" value={formData.city} onChange={(e) => setFormData({ ...formData, city: e.target.value })} />
                                                <label htmlFor="country" className="form-label">Country</label>
                                                <input type="text" className="form-control" id="country" name="country" value={formData.country} onChange={(e) => setFormData({ ...formData, country: e.target.value })} />
                                                <label htmlFor="zipcode" className="form-label">PostCode</label>
                                                <input type="text" className="form-control" id="zipcode" name="zipcode" value={formData.zipcode} onChange={(e) => setFormData({ ...formData, zipcode: e.target.value })} />
                                            </div>
                                            <div className="col-sm-6">
                                                <center><h5 className="card-title mb-3">Shipping address</h5></center>
                                                <label htmlFor="shipping_address" className="form-label">Address</label>
                                                <input type="text" className="form-control" id="shipping_address" name="shipping_address" value={formData.shipping_address} onChange={(e) => setFormData({ ...formData, address: e.target.value })} />
                                                <label htmlFor="shipping_city" className="form-label">City</label>
                                                <input type="text" className="form-control" id="shipping_city" name="shipping_city" value={formData.shipping_city} onChange={(e) => setFormData({ ...formData, shipping_city: e.target.value })} />
                                                <label htmlFor="shipping_country" className="form-label">Country</label>
                                                <input type="text" className="form-control" id="shipping_country" name="shipping_country" value={formData.shipping_country} onChange={(e) => setFormData({ ...formData, shipping_country: e.target.value })} />
                                                <label htmlFor="shipping_zipcode" className="form-label">PostCode</label>
                                                <input type="text" className="form-control" id="shipping_zipcode" name="shipping_zipcode" value={formData.shipping_zipcode} onChange={(e) => setFormData({ ...formData, shipping_zipcode: e.target.value })} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card mb-3">
                                    <div className="card-body">
                                        <div className="row mb-3">
                                            <div className="col-sm-6">
                                                <center><h5 className="card-title mb-3">Contact Information</h5></center>
                                                <label htmlFor="contact_fullname" className="form-label">Contact Full Name</label>

                                                <input type="text" className="form-control" id="contact_fullname" name="contact_fullname" value={formData.contact_fullname} onChange={(e) => setFormData({ ...formData, contact_fullname: e.target.value })} />

                                                <label htmlFor="contact_phone" className="form-label">Contact Phone</label>
                                                <input type="text" className="form-control" id="contact_phone" name="contact_phone" value={formData.contact_phone} onChange={(e) => setFormData({ ...formData, contact_phone: e.target.value })} />

                                                <label htmlFor="contact_email" className="form-label">Contact Email</label>
                                                <input type="email" className="form-control" id="contact_email" name="contact_email" value={formData.contact_email} onChange={(e) => setFormData({ ...formData, contact_email: e.target.value })} />
                                            </div>
                                            <div className="col-sm-6">
                                                <center><h5 className="card-title mb-3">References</h5></center>
                                                <label htmlFor="reference1" className="form-label">Reference 1</label>
                                                <input type="text" className="form-control" id="reference1" name="reference1" value={formData.reference1} onChange={(e) => setFormData({ ...formData, reference1: e.target.value })} />
                                                <label htmlFor="reference2" className="form-label">Reference 2</label>
                                                <input type="text" className="form-control" id="reference2" name="reference2" value={formData.reference2} onChange={(e) => setFormData({ ...formData, reference2: e.target.value })} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/*  <Link className="btn btn-warning" to="/profiles" style={{ marginRight: "5px" }}>Go back</Link>
                                        <button type="button" onClick={handleSubmit} className="btn btn-primary">Save changes</button> */}
                            </form>
                            <div className="col-md-12 mb-3">
                                <label htmlFor="comment" className="form-label">Comment</label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter comment"
                                    name="comment"
                                    value={formData.comment}
                                    onChange={(e) => setFormData({ ...formData, comment: e.target.value })}
                                ></textarea>
                            </div>
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="user_transaction" className="form-label">Status</label>
                                    <select
                                        className="form-select"
                                        aria-label=".form-select-sm example"
                                        name="est_id"
                                        value={formData.est_id}
                                        onChange={handleChange}
                                    >
                                        {formData.est_id === 1 ? (
                                            <>
                                                <option value="1">Activated</option>
                                                <option value="2">Disabled</option>
                                            </>
                                        ) : (
                                            <>
                                                <option value="2">Disabled</option>
                                                <option value="1">Activated</option>
                                            </>
                                        )}

                                    </select>

                                </div>
                                <br />
                            </div>
                            {/* User Info */}
                            <h4 className='p-3'>Other information</h4>
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="user_transaction" className="form-label">User Created</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.user_transaction}
                                        disabled
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="date_created" className="form-label">Date Created</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={vAdminformat.FormatDate(dateCreated)}
                                        disabled
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="user_created" className="form-label">User Modified</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={userModify}
                                        disabled
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="date_modify" className="form-label">Date Modified</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={vAdminformat.FormatDate(dateModify)}
                                        disabled
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="card-header align-items-center d-flex">
                            <div className="col-md-12">
                                <div className="text-end">
                                    <Link className='btn btn-danger' style={{ marginRight: "5px" }} onClick={() => {

                                        Swal.fire({
                                            icon: 'warning',
                                            title: 'Alert',
                                            text: "Are you sure you want to discard these changes?",
                                            showCancelButton: true,
                                            confirmButtonText: 'Accept',
                                            cancelButtonText: "Cancel"
                                        }).then(async (result) => {
                                            if (result.isConfirmed) {
                                                onClose();
                                            }
                                        }
                                        )
                                    }
                                    }>Discard Change</Link>
                                    <button className="btn btn-primary" type="submit" disabled={loading}>
                                        {loading ? 'Updating...' : 'Update'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default UpdateCustomer;
